import {Box, Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	padding: 16px;
	background-color: white;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		border-radius: 8px;
	}
`;

const StyledLabel = styled('label')`
	color: ${({theme}) => theme.palette.primary.main};
	font-weight: 600;
`;

const StyledForm = styled('form')`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-inline: auto;
		max-width: 852px;
		padding: 32px;
	}
`;

const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

export {StyledStack, StyledLabel, StyledForm, StyledFooterContainer};
